import { valueToExpressionSingle } from '@app/hcs-shared';
import { ModuleFE_Variable } from '../../../../_entity/variable/index.js';
import { ModuleFE_Value } from '../../../../_entity/value/index.js';
const getDataMappers = () => {
    return {
        variableMap: ModuleFE_Variable.cache.arrayToMap(item => item._id),
        valueMap: ModuleFE_Value.cache.arrayToMap(item => item._id)
    };
};
export const normalRangeToExpressionSingleFE = (coupling) => {
    const dataMappers = getDataMappers();
    return valueToExpressionSingle(coupling, dataMappers);
};
//# sourceMappingURL=normalRangeToExpressionFE.js.map